import { filterFieldCatalogue, filterOperatorCatalogue } from 'lib-search-ui';
import { memo } from 'react';

import { SearchScopeFilter } from 'components/search';

import { useSearchQuickFilter } from '../../utils/useSearchQuickFilter';

export const SearchChannelQuickFilter = memo(
  function SearchChannelQuickFilter(): JSX.Element {
    const { condition, handleChange } = useSearchQuickFilter('initial_channel');

    return (
      <SearchScopeFilter
        scope="channels"
        placeholder="Search channels..."
        operators={
          filterOperatorCatalogue.conversations.initial_channel.operators
        }
        defaultOperator={
          filterOperatorCatalogue.conversations.initial_channel.defaultOperator
        }
        selectedValues={condition?.values}
        selectedOperator={condition?.operator}
        onChange={handleChange}
      >
        {filterFieldCatalogue.conversations.initial_channel.label}
      </SearchScopeFilter>
    );
  },
);
